exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quotation-jumbotron {\r\n  background: #467fbf;\r\n  padding: 10px 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.ul-with-border {\r\n  border: 1px solid #467fbf;\r\n}\r\n\r\n.stepper-box {\r\n  margin-top: 5px;\r\n  padding-bottom: 10px;\r\n  border: 1px dashed #467fbf;\r\n}\r\n\r\n.full-width {\r\n  width: 100%;\r\n}\r\n\r\n.map {\r\n  height: 300px !important;\r\n}\r\n\r\n\r\n.form-container {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n}\r\n\r\n.form-container > * {\r\n  width: 100%;\r\n}\r\n\r\n.example-right-align {\r\n  text-align: right;\r\n}\r\n\r\ninput.example-right-align::-webkit-outer-spin-button,\r\ninput.example-right-align::-webkit-inner-spin-button {\r\n  display: none;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/app/pages/quotation/quotation.component.css
// module id = ../../../../../src/app/pages/quotation/quotation.component.css
// module chunks = main